export const DEFAULT_CONCURRENT_USERS_NUMBER = 5;

export const PLATFORM_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Shared Suite Capabilities",
  key: "platform",
  isCoreProduct: 1,
  isStartingProduct: 1,
  canBeRemoved: 0,
  properties: {
    loginPerSecond: 1,
    concurrentUsers: 5,
  },
};

export const ORCHESTRATOR_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Orchestrator",
  key: "orchestrator",
  isCoreProduct: 1,
  isStartingProduct: 1,
  canBeRemoved: 0,
  properties: {
    concurrentRobots: 5,
  },
};

export const ACTION_CENTER_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Action Center",
  key: "action_center",
  isCoreProduct: 1,
  isStartingProduct: 1,
  canBeRemoved: 1,
  properties: {
    concurrentUsers: DEFAULT_CONCURRENT_USERS_NUMBER,
  },
};

export const BUSINESS_APPS_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Apps",
  key: "apps",
  isCoreProduct: 0,
  isStartingProduct: 0,
  canBeRemoved: 1,
  properties: {
    concurrentUsers: DEFAULT_CONCURRENT_USERS_NUMBER,
  },
};
export const AI_CENTER_PRODUCT_OPTION: ProductOptionInterface = {
  name: "AI Center",
  key: "ai_center",
  isCoreProduct: 0,
  isStartingProduct: 0,
  canBeRemoved: 1,
  properties: {
    concurrentUsers: DEFAULT_CONCURRENT_USERS_NUMBER,
    numberOfSkills: 5,
    jobs: [],
    jobOptions: [
      {
        name: "English Text Classification",
        requests: 1,
        seconds: 6,
      },
      {
        name: "French Text Classification",
        requests: 1,
        seconds: 6,
      },
      {
        name: "Named Entity Recognition",
        requests: 1,
        seconds: 6,
      },
      {
        name: "Sentiment Analysis",
        requests: 1,
        seconds: 6,
      },
      {
        name: "Question Answering",
        requests: 1,
        seconds: 6,
      },
      {
        name: "Semantic Similarity",
        requests: 1,
        seconds: 6,
      },
      {
        name: "Text Summarization",
        key: "",
        requests: 1,
        seconds: 6,
      },
      {
        name: "Language Translation",
        requests: 1,
        seconds: 6,
      },
      {
        name: "Object Detection",
        requests: 1,
        seconds: 6,
      },
      {
        name: "Image Moderation",
        requests: 1,
        seconds: 6,
      },
      {
        name: "Tabular Classification",
        key: "",
        requests: 1,
        seconds: 6,
      },
      {
        name: "Tabular Regression",
        requests: 1,
        seconds: 6,
      },
      {
        name: "DU General Extractor",
        requests: 1,
        seconds: 6,
      },
      {
        name: "DU Invoices",
        requests: 1,
        seconds: 6,
      },
      {
        name: "DU Receipts",
        requests: 1,
        seconds: 6,
      },
      {
        name: "DU Purchase Orders",
        requests: 1,
        seconds: 6,
      },
      {
        name: "DU Utility Bills",
        requests: 1,
        seconds: 6,
      },
      {
        name: "DU OCR",
        requests: 1,
        seconds: 6,
      },
      {
        name: "Task Mining Analyzer",
        requests: 1,
        seconds: 6,
      },
    ],
  },
};

export const AUTOMATION_HUB_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Automation Hub",
  key: "automation_hub",
  isCoreProduct: 1,
  isStartingProduct: 1,
  canBeRemoved: 1,
  properties: {
    concurrentUsers: DEFAULT_CONCURRENT_USERS_NUMBER,
  },
};

export const TASK_MINING_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Task Mining",
  key: "task_mining",
  isCoreProduct: 0,
  isStartingProduct: 0,
  canBeRemoved: 1,
  properties: {
    concurrentUsers: DEFAULT_CONCURRENT_USERS_NUMBER,
  },
};

export const DOCUMENT_UNDERSTANDING_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Document Understanding",
  key: "document_understanding",
  isCoreProduct: 0,
  isStartingProduct: 0,
  canBeRemoved: 1,
  properties: {
    generalExtractorPerHour: 0,
    invoicesPerHour: 0,
    receiptsPerHour: 0,
    purchaseOrdersPerHour: 0,
    utilityBillsPerHour: 0,
    ocrPerHour: 0,
    shredsPerHour: 0,
  },
};

export const INSIGHTS_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Insights",
  key: "insights",
  isCoreProduct: 1,
  isStartingProduct: 1,
  canBeRemoved: 1,
  properties: {},
};

export const AUTOMATION_OPS_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Automation Ops",
  key: "automation_ops",
  isCoreProduct: 1,
  isStartingProduct: 1,
  canBeRemoved: 1,
  properties: {},
};

export const TEST_MANAGER_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Test Manager",
  key: "test_manager",
  isCoreProduct: 1,
  isStartingProduct: 1,
  canBeRemoved: 1,
  properties: {
    concurrentUsers: DEFAULT_CONCURRENT_USERS_NUMBER,
  },
};

export const DATA_SERVICE_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Data Service",
  key: "data_service",
  isCoreProduct: 1,
  isStartingProduct: 1,
  canBeRemoved: 1,
  properties: {
    concurrentUsers: DEFAULT_CONCURRENT_USERS_NUMBER,
  },
};

export const ALL_PRODUCT_OPTIONS = [
  PLATFORM_PRODUCT_OPTION,
  ORCHESTRATOR_PRODUCT_OPTION,
  ACTION_CENTER_PRODUCT_OPTION,
  BUSINESS_APPS_PRODUCT_OPTION,
  AI_CENTER_PRODUCT_OPTION,
  AUTOMATION_HUB_PRODUCT_OPTION,
  TASK_MINING_PRODUCT_OPTION,
  DOCUMENT_UNDERSTANDING_PRODUCT_OPTION,
  INSIGHTS_PRODUCT_OPTION,
  AUTOMATION_OPS_PRODUCT_OPTION,
  TEST_MANAGER_PRODUCT_OPTION,
  // Disabled until 22.4 is released
  // DATA_SERVICE_PRODUCT_OPTION,
];

export const CORE_PRODUCT_OPTIONS = ALL_PRODUCT_OPTIONS.filter(
  (option) => !!option.isCoreProduct
);

export const STARTING_PRODUCT_OPTIONS = ALL_PRODUCT_OPTIONS.filter(
  (option) => !!option.isStartingProduct
);
